var path = '@collectivehealth/get-care/components/providerTag/providerTag.html';
var html = "<div class=\"ProviderTag\" ng-repeat=\"tag in ProviderTag.displayTags\">\n  <dls-icon-circle-check class=\"ProviderTag__icon\"> </dls-icon-circle-check>\n  <span class=\"ProviderTag__text\">{{ tag.text }}</span>\n</div>\n";
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;